import React from "react";
import ContactSection from "../components/home/ContactSection";
import PageHero from "../components/PageHero";
import { useMedia, resolveUrl } from "../context/MediaContext";

export default function ContactPage() {
  const { slots } = useMedia();
  return (
    <div className="bg-[#F7F2E9] min-h-screen">
      <PageHero
        eyebrow="Get In Touch"
        title="Say"
        accent="Hello"
        image={resolveUrl(slots.patio)}
        subtitle="Have a question or ready to plan your stay? We'd love to hear from you."
      />
      <ContactSection />
    </div>
  );
}
